import * as React from "react";
import { Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import { AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet";
import './App.css';
import { Home } from './Home';
import { Choose } from './Choose';
import { Message } from './Message';
import { Done } from './Done';
import { View } from './View';

const App = () => {
  return (
    <div className="App">
      <Helmet>
          <meta charSet="utf-8" />
          <title>#あなたを選んで生まれてきた - 母の日に感謝を伝えよう！</title>
          <meta
            name="description"
            content="心温まる仏言の入ったカードに、あなたのメッセージを添えて。"
          />
      </Helmet>
      <AnimatePresence exitBeforeEnter initial={false}>
        <Routes>
          <Route path="mothersday2022" element={<Home />} />
          <Route path="mothersday2022/choose" element={<Choose />} />
          <Route path="mothersday2022/message" element={<Message />} />
          <Route path="mothersday2022/done" element={<Done />} />
          <Route path="mothersday2022/view" element={<View />} />
        </Routes>
      </AnimatePresence>
    </div>
  );
}

export default App;
